<template>
  <section class="content" style="padding-left: 0px;padding-right: 0px;">
    <div class="row" v-if="noContentItem==='yes' && !noContentErrorMsgItem">
      <!--        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">-->
      <vue-content-loading :width="300" :height="190">
        <rect x="0" y="0" rx="2" ry="2" width="25%" height="4"/>
        <rect x="0" y="7" rx="4" ry="4" width="100%" height="150"/>
        <rect x="0" y="160" rx="2" ry="2" width="100%" height="6"/>
        <rect x="0" y="170" rx="2" ry="2" width="100%" height="4"/>
        <rect x="0" y="177" rx="2" ry="2" width="100%" height="4"/>
      </vue-content-loading>
      <!--        </div>-->
    </div>
    <div class="row" v-if="noContentErrorMsgItem">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <router-link to="/documents"><p class="sg-top"><i class="fa fa-chevron-left" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;{{getDataDoc.name}}</p></router-link>
    </div>
    </div>
    <div class="row" v-if="noContentErrorMsgItem">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="sg-str" @click="favoritDocument(getDataDoc.id)">
          <i :class="[getDataDoc.favourite=='yes'?'fa fa-star':'fa fa-star-o']" aria-hidden="true">
          </i>
        </div>
        <!-- <div class="sg-full-video"> -->
          <!-- <iframe style="width:100%;height:500px" src="https://online.fliphtml5.com/nqffk/qves/"  seamless="seamless" scrolling="no" frameborder="0" allowtransparency="true" allowfullscreen="true" ></iframe> -->
          <iframe :src="'https://smartapprcp.s3.ap-southeast-1.amazonaws.com/'+getDataDoc.url" width="100%" height="650" frameborder="0" marginwidth="0" marginheight="0" scrolling="no" style="border:1px solid #CCC; border-width:1px; margin-bottom:5px; max-width: 100%; height: 700px;" allowfullscreen> </iframe>
        <!-- </div> -->
        <p class="sg-pname">{{getDataDoc.name}}</p>
        <p class="sg-disco">{{getDataDoc.description}}</p>
    </div>
    </div>
    <br>
    <br>
     <div class="row"  v-if="getOthers.length != 0">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="row">
          <div class="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3" v-for="doc in getOthers.slice(0, 4)">
            <div class="sg-str" @click="favoritDocument(doc.id)">
              <i :class="[doc.favourite=='yes'?'fa fa-star':'fa fa-star-o']" aria-hidden="true">
              </i>
            </div>
<!--            <router-link :to="'/documents/single-dcument/'+doc.category_id+'/'+doc.id">-->
              <a :href="$router.resolve({path: '/documents/single-dcument/'+doc.category_id+'/'+doc.id}).href">
            <div class="v-boxx">
              <div class="v-videoo">
                  <img class="doc-img" v-bind:src='"https://smartapprcp.s3.ap-southeast-1.amazonaws.com/" + doc.thumbnail ' >
              </div>
              <div class="v-content">
                <p class="v-name two-line-overflow">{{doc.name}}</p>
                <!-- <ul class="v-name two-line-overflow2" style="padding-left:0;" >
                  <li class="badge bgg-pr"  v-for="product in doc.products">
                    {{product.pro_name}}
                  </li>
                </ul> -->
                  <p class="v-disc two-line-overflow">{{doc.description}}</p>
              </div>
            </div>
              </a>
<!--            </router-link>-->
          </div>



        </div>
      </div>
    </div>
<!--    <div class="row" v-if="noContentItems==='no'">-->
<!--      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">-->
<!--        No results found-->
<!--      </div>-->
<!--    </div>-->
    <div class="row" v-if="noContentItems==='yes' && !noContentErrorMsgItems">
      <!--        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">-->
      <vue-content-loading :width="300" :height="100">
        <rect x="0" y="13" rx="4" ry="4" width="23%" height="50"/>
        <rect x="0" y="66" rx="2" ry="2" width="23%" height="3"/>
        <rect x="0" y="72" rx="2" ry="2" width="14%" height="3"/>
        <rect x="0" y="78" rx="2" ry="2" width="23%" height="3"/>
        <rect x="0" y="84" rx="2" ry="2" width="23%" height="3"/>

        <rect x="25%" y="13" rx="4" ry="4" width="23%" height="50"/>
        <rect x="25%" y="66" rx="2" ry="2" width="23%" height="3"/>
        <rect x="25%" y="72" rx="2" ry="2" width="14%" height="3"/>
        <rect x="25%" y="78" rx="2" ry="2" width="23%" height="3"/>
        <rect x="25%" y="84" rx="2" ry="2" width="23%" height="3"/>

        <rect x="51%" y="13" rx="4" ry="4" width="23%" height="50"/>
        <rect x="51%" y="66" rx="2" ry="2" width="23%" height="3"/>
        <rect x="51%" y="72" rx="2" ry="2" width="14%" height="3"/>
        <rect x="51%" y="78" rx="2" ry="2" width="23%" height="3"/>
        <rect x="51%" y="84" rx="2" ry="2" width="23%" height="3"/>

        <rect x="77%" y="13" rx="4" ry="4" width="23%" height="50"/>
        <rect x="77%" y="66" rx="2" ry="2" width="23%" height="3"/>
        <rect x="77%" y="72" rx="2" ry="2" width="14%" height="3"/>
        <rect x="77%" y="78" rx="2" ry="2" width="23%" height="3"/>
        <rect x="77%" y="84" rx="2" ry="2" width="23%" height="3"/>
      </vue-content-loading>
      <!--        </div>-->
    </div>
  </section>
</template>
<script>
  import api from '../../../api'

  import VueContentLoading from 'vue-content-loading'
  export default {
    name: 'homeView',
    components: {
      VueContentLoading
    },
    data() {
      return {
        getDataDoc: '',
        getOthers: [],
        noContentItems: 'yes',
        noContentItem: 'yes',
        noContentErrorMsgItem: false,
        noContentErrorMsgItems: false
      }
    },
    computed: {
    },
    created() {
      this.getSelectDocData()
    },
    methods: {
      getSelectDocData() {
        this.noContentErrorMsgItem = false
        this.noContentErrorMsgItems = false
        this.noContentItems = 'yes'
        api.request('get', '/media/documents/' + this.$route.params.cata + '/' + this.$route.params.id + '/m')
          .then(response => {
            this.getDataDoc = response.data.details
            this.getOthers = response.data.records
            if (response.data.records.length === 0) {
              this.noContentItems = 'no'
            }
            this.noContentErrorMsgItem = true
            this.noContentErrorMsgItems = true
          })
      },
      favoritVideo(id) {
        this.favouriteBackendCall('videos', id)
      },
      favoritDocument(id) {
        this.favouriteBackendCall('documents', id)
      },
      favouriteBackendCall(mediaType, id) {
        api.request('get', '/customer/favourite/' + mediaType + '/' + id)
          .then(response => {
            this.getSelectDocData()
          })
      }
    }

  }
</script>
<style>
  @media (min-width: 320px) and (max-width: 480px) {
    .video-list-thumbs .glyphicon-play-circle {
      font-size: 35px;
      right: 36%;
      top: 27%;
    }

    .video-list-thumbs h2 {
      bottom: 0;
      font-size: 12px;
      height: 22px;
      margin: 8px 0 0;
    }
  }
  .top-right {
    position: absolute;
    top: 8px;
    right: 16px;
  }
</style>



// WEBPACK FOOTER //
// SingleDocument.vue?1cdd903e